/**
 * Permet de comparer deux numéros de version au format XX.XX.XX
 * Fonctionne aussi avec des nombre classiques au format XX.
 * Exemples : 1.2.22, 1.10.0, 10.1.0, 93...
 *
 * Returns :
 *  version1 < version2 : 1 | version1 > version2 : -1 | version1 === version2 : 0
 *
 */
export const compareVersionName = (version1: string, version2: string): number => {
    const v1Splitted = version1.split('.').map(num => parseInt(num));
    const v2Splitted = version2.split('.').map(num => parseInt(num));

    // Si le format même des deux versions diffère, on fait la mise à jour
    if (v1Splitted.length !== v2Splitted.length) {
        return 1;
    }

    for (let i = 0; i < v1Splitted.length; i++) {
        if (v1Splitted[i] > v2Splitted[i]) return -1;
        if (v1Splitted[i] < v2Splitted[i]) return 1;
    }
    return 0;
};
